module.exports = __webpack_public_path__ + "img/47.4c59d6aa.svg";